import { SVGProps } from 'react'

const GasIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.4209 4.77036C14.1813 4.77036 13.9929 4.96293 13.9929 5.19841V12.7878C13.9929 13.2586 13.6119 13.6439 13.1453 13.6439C12.6744 13.6439 12.2935 13.2586 12.2935 12.7878V9.282C12.2935 8.34036 11.5316 7.56979 10.5898 7.56979H9.74215V1.92805C9.74215 1.69257 9.55376 1.5 9.31409 1.5H1.57918C1.33951 1.5 1.15112 1.69257 1.15112 1.92805V14.0719C1.15112 14.3074 1.33951 14.5 1.57918 14.5H9.31409C9.55376 14.5 9.74215 14.3074 9.74215 14.0719V8.4259H10.5898C11.0606 8.4259 11.4374 8.81118 11.4374 9.282V12.7878C11.4374 13.7338 12.2036 14.5 13.1453 14.5C14.0827 14.5 14.849 13.7338 14.849 12.7878V5.19841C14.8489 4.96293 14.6563 4.77036 14.4208 4.77036H14.4209ZM6.59185 5.3096H4.30181C3.94649 5.3096 3.65973 5.02284 3.65973 4.66752C3.65973 4.31652 3.94649 4.02544 4.30181 4.02544H6.59185C6.94717 4.02544 7.23393 4.31652 7.23393 4.66752C7.23393 5.02284 6.94717 5.3096 6.59185 5.3096Z"
      fill="currentColor"
    />
  </svg>
)

export default GasIcon
